import { CatButton } from '@blocks-react/components/Button';
import { BUTTON_VARIANTS } from '../../../../src/constants/commonConstants';
import { FC, PropsWithChildren } from 'react';

interface GaAttributes {
  'data-track-event': string;
  'data-track-attr-nltext': string;
  'data-track-attr-context': string;
}

interface RegisterButtonProps {
  className?: string;
  onClick?: (event: MouseEvent) => void;
  href?: string;
  variant?: BUTTON_VARIANTS;
  fullWidth?: boolean;
  gaAttributes?: GaAttributes;
}

export const RegisterButton: FC<PropsWithChildren<RegisterButtonProps>> = ({
  children,
  className,
  onClick,
  href,
  variant,
  fullWidth = true,
  gaAttributes = {}
}) => {
  return (
    <CatButton
      className={className}
      fullWidth={fullWidth}
      onClick={onClick}
      data-testid="register-button"
      href={href}
      variant={variant}
      {...gaAttributes}
    >
      {children}
    </CatButton>
  );
};
